// Pop Market reads from the seed collections by default. This keeps
// the public directory looking populated even before real signups
// come in. Visitors aren't shown any indication that this is seed
// data — internally we just call this "preview" mode.
//
// `?live=1` in the URL forces a switch to the empty live collections
// (used internally for admin testing).

const KEY = "popMarketLive";

export function isDemoMode() {
  if (typeof window === "undefined") return true;
  const params = new URLSearchParams(window.location.search);
  if (params.get("live") === "1") {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    return false;
  }
  if (params.get("live") === "0" || params.get("demo") === "1") {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
    return true;
  }
  try { return localStorage.getItem(KEY) !== "1"; } catch { return true; }
}

export function sellersCollectionName() {
  return isDemoMode() ? "pop_market_sellers_seed" : "pop_market_sellers";
}

export function reviewsCollectionName() {
  return isDemoMode() ? "pop_market_reviews_seed" : "pop_market_reviews";
}
